const sizeConfigs = {
  sidebar: {
    width: "15%"
  }
};

export default sizeConfigs;